import { useState } from "react";
import useUser from "../../../../core/hooks/use-user";
import useModal from "../../../../core/hooks/use-modal";
import Datatable from "../../../../core/ui/components/Datatable";
import { toast } from "../../../../core/helpers/message-helper";
import { API_DOMAIN, API_URL } from "../../../../core/config/env";
import ContentWrapper from "../../../../core/ui/components/Layout/ContentWrapper";
import FormSedes from "../components/form-sedes";
import {
    cambiarEstadoSede,
    obtenerSedePorId,
} from "../../services/sedes-service";
import { sweetAl } from "../../../../core/helpers/message-helper";

const Sedes = () => {
    const { getAccessToken, userCan } = useUser();
    const token = getAccessToken();
    const [dtInstance, onDtInstance] = useState();

    const modalSedes = useModal({
        title: "Crear Sede",
        data: { sede: {} },
    });

    const getDtInstance = (dt) => onDtInstance(dt);
    const onCrearOEditarSede = () => dtInstance.ajax.reload();

    async function onCambiarEstadoSede(idSede, estado, table) {
        const accion = estado == 1 ? "activar" : "inactivar";
        const value = await sweetAl.confirm(
            `¿Seguro que desea ${accion} esta sede?`
        );

        if (value == true) {
            const resp = await cambiarEstadoSede(idSede, estado);

            if (!resp.status) {
                return sweetAl.error(resp.message);
            }

            sweetAl.success(resp.message);
            table.ajax.reload();
        }
    }

    let tableButtons = [];
    if (userCan('sedesCrearSede')) {
        tableButtons.push({
            titleAttr: "Crear Sede",
            text: '<i class="fas fa-plus"></i>',
            action: function () {
                modalSedes.open({
                    title: "Crear Sede",
                    data: { sede: {} },
                });
            },
            className: "btn btn-sm btn-secondary",
        });
    }

    if (userCan('sedesEditarSede')) {
        tableButtons.push({
            titleAttr: "Editar Sede",
            text: '<i class="fas fa-pen"></i>',
            action: async (_, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                const resp = await obtenerSedePorId(data.id);
                if (!resp.status) return toast.error(resp.message);

                modalSedes.open({
                    title: "Editar Sede",
                    data: { sede: resp.data },
                });
            },
            className: "btn btn-sm btn-grey",
        });
    }

    if (userCan('sedesActivarSede')) {
        tableButtons.push({
            titleAttr: "Activar Sede",
            text: '<i class="fas fa-check"></i>',
            className: "btn btn-sm btn-primary",
            action: async (e, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                onCambiarEstadoSede(data.id, 1, dt);
            },
        });
    }

    if (userCan('sedesInactivarSede')) {
        tableButtons.push({
            titleAttr: "Inactivar Sede",
            text: '<i class="fas fa-trash"></i>',
            className: "btn btn-sm btn-danger",
            action: async (e, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                onCambiarEstadoSede(data.id, 0, dt);
            },
        });
    }

    tableButtons = [
        ...tableButtons,
        {
            titleAttr: "Exportar a Excel",
            text: '<i class="fas fa-file-excel"></i>',
            extend: "excelHtml5",
            className: "btn btn-sm btn-success",
            exportOptions: {
                modifier: {
                    order: "current",
                    page: "all",
                },
            },
            filename: "Sedes",
        },
        {
            titleAttr: "Imprimir",
            text: '<i class="fa fa-lg fa-print"></i>',
            extend: "print",
            className: "btn btn-sm btn-warning",
        },
    ];

    const dtOptions = {
        searchable: true,
        serverSide: false,
        dom: "Bfrtip",
        id: "tableSedes",
        select: {
            style: "single",
        },
        buttons: tableButtons,
        ajax: {
            url: `${API_URL}/sedes`,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", `Bearer ${token}`);
            },
            type: "get",
            dataType: "json",
            error: function () {
                toast.error(
                    "Ha ocurrido un error al obtener el listado de las sedes"
                );
            },
        },
        columns: [
            { data: "id" },
            { data: "nombre" },
            { data: "sigla" },
            { data: "img", defaultContent: "" },
            { data: "status" },
        ],
        columnDefs: [
            {
                target: [3],
                createdCell: function (td, cellData) {
                    const path = `${API_DOMAIN}${cellData}`;
                    td.innerHTML = `
                        <img
                            src='${path}'
                            class='rounded-circle'
                            width='50px'
                            height='50px'
                            onerror="this.src='img/logo_csr_big.png'"
                        />
                    `;
                },
            },
            {
                targets: 4,
                createdCell: function (td, cellData) {
                    td.textContent = cellData == 1 ? "Activo" : "Inactivo";
                    td.classList.add(
                        cellData == 1 ? "text-success" : "text-warning"
                    );
                    td.classList.add("text-bold");
                },
            },
        ],
    };

    return (
        <ContentWrapper>
            <div className="content-heading">
                <div>
                    ADMINISTRAR / Sedes
                </div>
            </div>
            <Datatable options={dtOptions} dtInstance={getDtInstance}>
                <table
                    className="w-100 table table-hover text-center"
                    id="tableSedes"
                >
                    <thead className="bg-dark">
                        <tr>
                            <th className="text-center text-white">Id</th>
                            <th className="text-center text-white">Nombre</th>
                            <th className="text-center text-white">Sigla</th>
                            <th className="text-center text-white">Imágen</th>
                            <th className="text-center text-white">Estado</th>
                        </tr>
                    </thead>
                </table>
            </Datatable>
            <FormSedes modalState={modalSedes} onSave={onCrearOEditarSede} />
        </ContentWrapper>
    );
};

export default Sedes;
